import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import axios from 'axios';
import Button from '../../components/Button';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { Link } from 'react-router-dom';

const JobApplications = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addTeacherModal, setAddTeacherModal] = useState(false); // Modal for Add Teacher
  const [cnicModal, setCnicModal] = useState(false); // Modal for CNIC Image
  const [selectedCnicImage, setSelectedCnicImage] = useState(null); // State to store CNIC image URL
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCourses = teachers.filter((course) => {
    const matchesSearchQuery = course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });
  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    setLoading(true); // Set loading to true when API is being called
    fetch('https://quran-backend-theta.vercel.app/v1/admin/all-application', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setTeachers(data?.data);
        setLoading(false); // Set loading to false once data is received
      })
      .catch((error) => {
        console.error(error);
        setLoading(false); // In case of an error, stop loading
      });
  }, []);

  // Function to handle CNIC click and open modal
  const handleCnicClick = (cnicImage) => {
    setSelectedCnicImage(cnicImage); // Store CNIC image URL
    setCnicModal(true); // Open CNIC image modal
  };

  // Function to handle delete
  const handleDelete = async (id) => {
    try {
      const requestOptions = {
        method: 'DELETE',
        redirect: 'follow'
      };

      const response = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/hired/${id}`,
        requestOptions
      );
      const result = await response.json();

      if (result.success) {
        // Remove the deleted teacher from the state
        setTeachers((prevTeachers) => prevTeachers.filter((teacher) => teacher._id !== id));
        toast.success('Record deleted successfully.');
      } else {
        toast.error(result.message || 'Failed to delete record.');
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while deleting the record.');
    }
  };

  return (
    <Wrapper
      searchBar={
        <Input
          placeholder={`Search by name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <div className="flex justify-between items-center ">
        <div>
          <h2 className="main_title ">Job Applications</h2>
          <p className="text-[#1C1D1D]">Here are the details of all job applications</p>
        </div>
        <div className="cursor-pointer">
          {/* <img
            onClick={() => setAddTeacherModal(true)}
            src={require('../../assets/image/add.png')}
            alt=""
          /> */}
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center">
          <p>Loading...</p>
        </div>
      ) : (
        <section className="mb-20 mt-7">
          <div className="rounded-lg overflow-x-auto">
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead className="">
                        <tr className="rounded-lg whitespace-nowrap">
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            S No.
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Name
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Father Name
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Phone no
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Address
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Qualification
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            CNIC Copy
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Active
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredCourses?.map((teacher, index) => (
                          <tr key={teacher?._id} className="bg-white shadow-lg mt-6 rounded-lg">
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                {index + 1}
                              </span>
                            </td>
                            <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                {teacher?.name}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.fatherName}
                              </span>
                            </td>
                            <td className="align-middle bg-white font-normal px-6 py-3 whitespace-nowrap text-left">
                              <div className="flex flex-col">
                                <span className="bg-green-200 text-xs text-[#858585] px-2.5 leading-none whitespace-nowrap rounded-full">
                                  whatsapp no
                                </span>
                                <span className="bg-green-200 text-[#1C8E00] px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.whatsapp}
                                </span>
                                <span className="bg-green-200 text-xs text-[#858585] px-2.5 leading-none whitespace-nowrap rounded-full">
                                  Other
                                </span>
                                <span className="bg-green-200 text-black px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.phone}
                                </span>
                              </div>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className="bg-green-200 text-base text-black px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.address}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className="bg-green-200 text-base text-black px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.qualification}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <Link
                                to={teacher?.cnicImage}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-secondary"
                              >
                                {teacher?.cnicImage?.split('/').pop()}
                              </Link>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 whitespace-nowrap text-left">
                              <img
                                className="cursor-pointer"
                                src={require('../../assets/image/del.png')}
                                alt="Delete"
                                onClick={() => handleDelete(teacher?._id)} // Call handleDelete with the teacher ID
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Modal to show CNIC image */}
      {cnicModal && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-4 rounded-lg shadow-xl relative max-w-sm w-full">
              {selectedCnicImage && (
                <img src={selectedCnicImage} alt="CNIC" className="w-full h-auto mb-4" />
              )}
              <div className="flex justify-end ">
                <button
                  onClick={() => setCnicModal(false)} // Replace with your state management to close the modal
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default JobApplications;
